import { DataBean } from "../DataBean";

export class ProcedureImp extends DataBean{

    PENDING_FOR_INPUT=0;
    FOR_VERIFY = 1;
    RETURNED = 2;
    VERIFIED = 3;
    SUBMITTED = 4;
    REJECTED = 5;

    public async getActualProcedureActionByProcedureImp(idProcedureImp:number): Promise<any> {
        return this.getCustomService("BpmService", "java.util.List_getActualProcedureActionByProcedureImp_Number", [idProcedureImp]);
    }
    public async getProcedureDocument(idDocument:number): Promise<any> {
        return this.getCustomService("BpmService", "com.quickbpm.bean.ProcedureDocument_getProcedureDocument_Number", [idDocument]);
    }
    public async getRemoteAbstractActionByClassForName(classForName:string): Promise<any> {
        return this.getCustomService("OrangeCore", "com.advantage.bean.dev.RemoteAbstractAction_getRemoteAbstractActionByClassForName_String", 
            [classForName]);
    }
    public async getHiringModalityDocument(idHiringModalityDocument:number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.HiringModalityDocument_getHiringModalityDocument_Number", 
            [idHiringModalityDocument]);
    }
    public async putDocumentTRD(idProcedureImp:number,idEmployee:number,document:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.RecordDocumentTRD_putDocumentTRD_Number_Number_com.orange.bean.supplier.HiringModalityDocument", 
            [idProcedureImp,idEmployee,document]);
    }
    public async deleteDocumentTRD(idRecordDocumentTRD:number,idEmployee:number): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.RecordDocumentTRD_deleteDocumentTRD_Number_Number", 
            [idRecordDocumentTRD,idEmployee]);
    }
    public async getRequestProcessBpmByImp(idProcedureImp:number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.RequestProcessBpm_getRequestProcessBpmByImp_Number", 
            [idProcedureImp]);
    }


    

}